{
  /* eslint-disable @typescript-eslint/ban-ts-comment */
}
import * as React from "react";
import { AIDocumentsTable } from "./Components/AIDocumentsTable";
import { Route, Navigate, Routes } from "react-router-dom";
import { observer } from "mobx-react";
import { CollectionFolder } from "./CollectionFolder/CollectionFolder";
import { DocumentsPage } from "./Pages/DocumentsPage";
import { DocumentsSearch } from "./Pages/DocumentsSearch";
import { breadcrumbsStore } from "./Stores/BreadcrumbsStore";
import { documentsTableStore } from "./Stores/DocumentsTableStore";
import { getUrlParams } from "utils/getUrlParams";
import { wopiViewerStore } from "Stores/WOPIViewerStore";
import { collectionFolderStore } from "./CollectionFolder/CollectionFolderStore";
import { API } from "General/API";
import { API_URL } from "General/APIEndpoints";
import { projectsDataStore } from "Stores";
import { ViewsOverview } from "../Views/Pages/ViewsOverview";
import { withRouter, WithRouterProps } from "Components/General/WithRouter";

type Queries = "folderId" | "wopiFileId" | "archived" | "edit";
type Params = { [key in Queries]?: string };

export const Documents = withRouter(
  observer(
    class Documents extends React.Component<WithRouterProps> {
      componentDidMount() {
        if (this.props.location.search) {
          const params: Params = getUrlParams(this.props.location.search);
          if (params.wopiFileId) {
            if (params.folderId) {
              this.props.navigate(`${params.folderId}`);
            }
            (async () => {
              try {
                let fileName = "";
                const file = await API.getBlob(
                  API_URL.FILES.getFileById(projectsDataStore.projectId, params.wopiFileId)
                );
                fileName = file.name;
                await wopiViewerStore.fetch(+params.wopiFileId, {
                  fileName,
                  archived: !!params.archived,
                  edit: !!params.edit,
                });
              } catch (error) {
                throw error;
              }
            })();
          }
        }
      }

      componentWillUnmount() {
        breadcrumbsStore.reset();
        documentsTableStore.reset();
        collectionFolderStore.reset();
      }

      render() {
        return (
          <>
            <CollectionFolder />
            <Routes>
              <Route path="*" element={<Navigate to={`docs`} replace />} />
              <Route path="docs/search-results" element={<DocumentsSearch />} />
              <Route
                path="docs/metadata-overview"
                element={<Navigate to={`/project/${projectsDataStore.projectId}/documents/docs`} replace />}
              />
              {/* @ts-ignore */}
              <Route path="docs" element={<DocumentsPage />}>
                {/* @ts-ignore */}
                <Route path={`:folderId`} element={<DocumentsPage />} />
                <Route path={`ai`} element={<AIDocumentsTable matchUrl={`/docs/ai`} />} />
                <Route path={`ai/:folderId`} element={<AIDocumentsTable matchUrl={`/docs/ai`} />} />
                {/* @ts-ignore */}
                <Route index element={<DocumentsPage />} />
              </Route>
              <Route path={`views`} element={<ViewsOverview />} />
            </Routes>
          </>
        );
      }
    }
  )
);

export default Documents;
